import { PatientProfilePage } from '../components/pages/contact/patient-profile/patient-profile-page-with-provider';
import { Dashboard as KaynDashboard } from '../components/pages/kayn/dahsboard/dashboard';

export const AppRoutes = [
  { private: true, path: '/*', component: PatientProfilePage },
  { private: true, exact: true, path: '/patient-profile', component: PatientProfilePage },
  { private: true, exact: true, path: '/kayn/dashboard', component: KaynDashboard }
];

export const AppPaths = AppRoutes.map((a) => a.path);
